import BackgroundVideo from "@/components/Shared/BackgroundVideo";
import mq from "@/utils/mq";
import { render } from "storyblok-rich-text-react-renderer";
import styled, { css } from "styled-components";

const VideoHeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  position: relative;
  width: 100vw;
  height: 100vh;
  z-index: 5;
  max-height: 900px;
  max-width: 100%;
  overflow: hidden;
  ${mq.mobile(css`
    max-height: unset;
    height: 90lvh;
    min-height: 400px;
  `)};
`;

const BackgroundVideoContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  z-index: 1;
  mask-image: linear-gradient(
    to bottom,
    #000 calc(100% - 160px),
    rgba(0, 0, 0, 0.2) calc(100% - (160px / 4)),
    transparent 100%
  );
  * {
    video {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }
`;

const CoverLeft = styled.div`
  position: absolute;
  inset: 0 auto 0 0;
  width: 50%;
  background: linear-gradient(to right, #08090a, #08090ab6, transparent);
  z-index: 2;
`;

const CoverRight = styled.div`
  position: absolute;
  inset: 0 0 0 auto;
  width: 50%;
  background: linear-gradient(to left, #08090a, #08090ab6, transparent);
  z-index: 2;
`;

const VideoWrapper = styled.div<{ $active: boolean; $opacity: number }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${(props) => props.$opacity};
  transition: opacity 0.8s ease-in-out;
  z-index: ${(props) => (props.$active ? 1 : 0)};
  filter: blur(4px) brightness(0.5);
`;

const ContentWrapper = styled.div`
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 5;
  ${mq.mobile(css`
    padding: 16px;
  `)};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 532px;
  ${mq.mobile(css`
    gap: 16px;
  `)};
`;

const Title = styled.h1`
  color: #f7f8f8;
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 2.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: 2.75rem;
  ${mq.mobile(css`
    font-size: 36px;
    line-height: 42px;
    text-wrap: pretty;
    letter-spacing: -0.37px;
    margin-bottom: 0px;
  `)};
`;

const Description = styled.div`
  color: #b7bac1;
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-family: Inter;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.4375rem;
  max-width: 430px;
`;

export default function VideoHero({ title, description, ctas, backgroundVideo, backgroundPoster }) {
  return (
    <VideoHeroContainer>
      <ContentWrapper>
        <ContentContainer>
          <Title>{title}</Title>
          <Description>{render(description)}</Description>
        </ContentContainer>
      </ContentWrapper>
      <BackgroundVideoContainer>
        <CoverLeft />
        <CoverRight />
        <VideoWrapper $active={true} $opacity={1}>
          <BackgroundVideo
            videoSrc={backgroundVideo.filename}
            posterSrc={backgroundPoster.filename}
            videoAlt={backgroundVideo.alt}
            posterAlt={backgroundPoster.alt}
          />
        </VideoWrapper>
      </BackgroundVideoContainer>
    </VideoHeroContainer>
  );
}
